import PropTypes from 'prop-types';

export const giftCardCandidateProps = {
  deliveryDate: PropTypes.string,
  deliveryOption: PropTypes.string,
  fromName: PropTypes.string,
  id: PropTypes.string,
  gifteeEmail: PropTypes.string,
  gifteeName: PropTypes.string,
  giftCardTemplateId: PropTypes.string,
  message: PropTypes.string,
  originalAmountCents: PropTypes.number,
};

export const giftCardCandidate = PropTypes.shape(giftCardCandidateProps);
